import type { ChecklistItem } from '../types';

/**
 * Computes the 0-based insertion index for a moved checklist item.
 *
 * The source item is excluded from the target list first (so moving within the
 * same checklist doesn't count itself), then:
 * - dropped on another item → insert at that item's position
 * - dropped on empty space / unknown target → append to the end
 *
 * @param targetItems items of the destination checklist (any order)
 * @param sourceItemId id of the item being moved
 * @param targetItemId id of the item it was dropped on, or undefined to append
 */
export function computeMoveOrder(
  targetItems: ChecklistItem[],
  sourceItemId: string,
  targetItemId?: string,
): number {
  const base = targetItems
    .filter((i) => i.id !== sourceItemId)
    .slice()
    .sort((a, b) => a.order - b.order);

  if (!targetItemId) return base.length;

  const idx = base.findIndex((i) => i.id === targetItemId);
  return idx === -1 ? base.length : idx;
}
